import { PropsWithChildren, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import {
  ExperimentProvider as BaseExperimentProvider,
  type ExposureConditionsMap,
} from '@growtherapy/analytics/client';

import { LAYER_CONFIGS } from './layerConfigs';

/**
 * Wraps the analytics ExperimentProvider with telehealth's layer configs and
 * readiness conditions required by `useDelayedExperiment`.
 */
export function ExperimentProvider({ children }: PropsWithChildren) {
  const { pathname } = useLocation();

  const experimentConditions: ExposureConditionsMap = useMemo(
    () => ({
      userAuthenticated: ({ statsigUser }) => !!statsigUser.userID,
    }),
    [],
  );

  return (
    <BaseExperimentProvider
      config={LAYER_CONFIGS}
      experiments={{}}
      featureFlags={{}}
      pathname={pathname}
      conditions={experimentConditions}
    >
      {children}
    </BaseExperimentProvider>
  );
}
